module.exports = __webpack_public_path__ + "img/food.af9d239f.svg";